import { z } from "zod";

export const SECTION_KEY_OPTIONS = [
  { value: "income", label: "Income" },
  { value: "cogs", label: "Cost of Goods Sold" },
  { value: "expenses", label: "Expenses" },
  { value: "otherIncome", label: "Other Income" },
  { value: "otherExpenses", label: "Other Expenses" },
] as const;

// `requireOrganization` is true when the form is opened from a multi-company View,
// where the entry's company can't be inferred from context and must be picked explicitly.
export const createVirtualPlEntrySchema = (requireOrganization: boolean) =>
  z.object({
    sectionKey: z.enum(["income", "cogs", "expenses", "otherIncome", "otherExpenses"]),
    lineName: z.string().min(1, "Line name is required").max(200),
    amount: z.coerce.number().refine((v) => v !== 0, "Amount can't be zero"),
    effectiveMonth: z.string().regex(/^\d{4}-\d{2}$/, "Select a month"),
    description: z.string().max(1000).optional(),
    organizationId: requireOrganization ? z.string().min(1, "Company is required") : z.string().optional(),
  });

export type CreateVirtualPlEntryFormValues = z.infer<ReturnType<typeof createVirtualPlEntrySchema>>;
